export abstract class DatadogGateway {
  abstract setUser(id?: string, organization?: string): void;
}
